export class Question {
    index: number = 0;
    domain: string = "";
    majorSkill: string = "";
    detailSkill: string = "";
    description: string = "";


    constructor(_index: number, _domain: string, _majorSkill: string, _detailSkill: string, _description: string) {
        this.index = _index;
        this.domain = _domain;
        this.majorSkill = _majorSkill;
        this.detailSkill = _detailSkill;
        this.description = _description;
    }

}


